import React from "react";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-image-crop/dist/ReactCrop.css";

import "./index.css";
import "./i18n";

import App from "./App";
import AppThemeProvider from "./providers/AppThemeProvider";
import { UserProvider } from "./contexts/UserContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AppThemeProvider>
    <UserProvider>
      <ToastContainer
        autoClose={25000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
        position="bottom-right" />

      <App />
    </UserProvider>
  </AppThemeProvider>
);
